import React, { useState } from 'react';
import { AccordionContainer } from '../../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../../common/components/form/form.module';
import ListEmailPlans from './email-plans';


const EMAIL_TEMPLATE_TYPE = 20;

export const TemplatesEmailInfoComponent = ({
  choosenEmailTemplate,
  selectedPlanId, setSelectedPlanId,
  handleInnerFormChange,
}: any) => {

  const [mappedEntities, setMappedEntities] = useState([]);

  const handlePlanIdChange = (planId: any, planData: any) => {
    if (planId && planData) {
      setMappedEntities([
        {
          Id: 0,
          OwnerTypeId: 70,
          OwnerId: planId,
          OwnerTypeName: 'EmailPlan',
          OwnerName: planData?.Name ?? 'string',
          Name: planData?.Name ?? 'string',
          Description: planData?.Description ?? 'string',
          IsFunction: true,
          IsDomain: false,
          MarketingTemplateId: 0,
          IsApproved: true,
          DisplayOrder: 0,
        },
      ]);
    }
  };


  return (
    <>

      <AccordionContainer
        child={
          <div className='w-full grid grid-cols-1 md:grid-cols-2 gap-4'>
            <InputContainer
              label="Name"
              labelField="Name"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(event.target.value, 'Name');
              }}
              type="text"
              value={choosenEmailTemplate?.Name}
            />

            <InputContainer
              label="Subject"
              labelField="Subject"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(event.target.value, 'Subject');
              }}
              type="text"
              value={choosenEmailTemplate?.Subject}
            />

            <InputContainer
              label="BodyContent"
              labelField="BodyContent"
              className="h-60 col-span-full"
              onValueChange={(event: any) => {
                handleInnerFormChange(event, 'BodyContent');
              }}
              type="rte"
            readOnly
              value={choosenEmailTemplate?.BodyContent || "Dear User, We’re grateful to you for choosing us! Your support means the world to us. Ready to join our upcoming programs?, Check it out in our site. Thank You - DIGIIT Business Services"}
            />
          </div>
        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
      />


      <AccordionContainer
        child={
          <ListEmailPlans
            setSelectedPlanId={setSelectedPlanId}
            selectedPlanId={selectedPlanId}
            choosenEmailTemplate={choosenEmailTemplate}
            handleInnerFormChange={handleInnerFormChange}
            onPlanIdChange={handlePlanIdChange}

          />
        }
        expandedPanel="Plans"
        headerTitle="Select a Plan"
      />
    </>
  );
};

export default TemplatesEmailInfoComponent;
